import { Font } from "@react-pdf/renderer";

// Report typefaces: Inter for body text (vendored full TTFs — the Google
// Fonts "latin" subset lacks the ₹ glyph) and Playfair Display for serif
// display titles. Files live in public/fonts/report so the same bytes can be
// reached by URL in the browser bundle and by file path from the Node sample
// script (scripts/render-sample-report.mjs).
//
// registerReportFonts() must run once before pdf(...).toBlob()/renderToFile.
// resolveSrc maps a font filename to a source; the default builds a public
// URL for the browser. Re-registering with a different resolver is allowed.

import { BODY_FONT, DISPLAY_FONT } from "./theme";

const browserSrc = (file) => `${process.env.PUBLIC_URL || ""}/fonts/report/${file}`;

export function registerReportFonts(resolveSrc = browserSrc) {
  Font.register({
    family: BODY_FONT,
    fonts: [
      { src: resolveSrc("inter-400.ttf"), fontWeight: 400 },
      { src: resolveSrc("inter-600.ttf"), fontWeight: 600 },
      { src: resolveSrc("inter-700.ttf"), fontWeight: 700 },
    ],
  });
  Font.register({
    family: DISPLAY_FONT,
    fonts: [
      { src: resolveSrc("playfair-600.ttf"), fontWeight: 600 },
      { src: resolveSrc("playfair-700.ttf"), fontWeight: 700 },
    ],
  });
}
